import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
};

const NavBar = (props) => {
  const { classes } = props;
  const { user } = props;
  
  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Toolbar>
          <a href="/"><img src="/w/assets/legter_logo.png" alt="Legter.hu logo" style={{width:50}}/></a>
          <Button color="inherit" onClick={()=>{document.location = '/'}}>Vissza a térképre</Button>
          {!user && (
            <React.Fragment>
              <Button color="inherit" component={props => <NavLink to="/w/login" {...props}/>}>Belépés</Button>
              <Button color="inherit" component={props => <NavLink to="/w/register" {...props}/>}>Regisztráció</Button>
            </React.Fragment>
          )}
          {user && (
            <React.Fragment>
              <Button color="inherit" component={props => <NavLink to="/w/subscriptions" {...props}/>}> Előfizetés</Button>
              <Button color="inherit" component={props => <NavLink to="/w/profile" {...props}/>}>Profilom ({user.name})</Button>
              <Button color="inherit" component={props => <NavLink to="/w/logout" {...props}/>}>Kilépés</Button>
            </React.Fragment>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavBar);
